import React from 'react';
import useTheme from '../../utilities/hooks/theme';
import { isSmartPhone } from '../../utilities/helper';
import CountdownTimer from '../countdown_timer';
import View from '../view';
import Text from '../text';
import HeaderWithTimerWeb from './index_web';
import HeaderWithTimerMWeb from './index_mWeb';
interface CounterWrapperProps {
  matchItem?: any;
  isMatchScheduled?: boolean;
  onCalledDeadline: any;
  verified?: boolean;
  matchStatus?: number;
  gameType?: string;
}

export const CounterWrapper = ({
  matchItem,
  isMatchScheduled,
  onCalledDeadline,
  verified,
  matchStatus,
  gameType
}: CounterWrapperProps) => {
  const { ComponentTheme } = useTheme();
  const timeStyle = {
    color: ComponentTheme.headerTitle
  };
  return (
    <>
      {isMatchScheduled ? (
        <View className="header-with-timer-counter-wrapper">
          <CountdownTimer
            style={{
              fontFamily: 'ProximaNova-SemiBold',
              fontSize: '1.1rem',
              paddingRight: '8px',
              color: '#ffc600',
              marginBottom: 0,
              textAlign: 'center'
            }}
            onCalledDeadline={onCalledDeadline}
            isShowAlert={true}
            matchItem={matchItem}
            gameType={gameType}
          />
        </View>
      ) : matchStatus === 2 && !verified ? (
        <View className="header-with-timer-counter-wrapper">
          <Text className="header-with-timer-counter-timer" style={timeStyle}>
            {'(Reviewed)'}
          </Text>
        </View>
      ) : matchStatus === 2 ? (
        <View className="header-with-timer-counter-wrapper">
          <Text className="header-with-timer-counter-timer" style={timeStyle}>
            {'(Completed)'}
          </Text>
        </View>
      ) : matchStatus === 3 ? (
        <View className="header-with-timer-counter-wrapper">
          <Text className="header-with-timer-counter-timer" style={timeStyle}>
            {'(Live)'}
          </Text>
        </View>
      ) : (
        <View className="header-with-timer-counter-wrapper">
          <Text className="header-with-timer-counter-timer" style={timeStyle}>
            {'(Abandoned)'}
          </Text>
        </View>
      )}
    </>
  );
};

interface Props {
  matchItem?: any;
  onPressBack?: React.MouseEventHandler;
  onlyTimer?: boolean;
  tabType?: string;
  onCalledDeadline?: any;
  onlyTitle?: any;
  screen?: string;
  teamName?: string;
  gameType?: string;
  isCreateTeam?: boolean;
}

const HeaderWithTimer = ({
  matchItem,
  onPressBack,
  onlyTimer = false,
  onlyTitle = false,
  onCalledDeadline,
  teamName = '',
  gameType,
  isCreateTeam = true
}: Props) => {
  return (
    <React.Fragment>
      {!isSmartPhone ? (
        <HeaderWithTimerWeb
          matchItem={matchItem}
          onPressBack={onPressBack}
          onlyTimer={onlyTimer}
          onlyTitle={onlyTitle}
          onCalledDeadline={onCalledDeadline}
          teamName={teamName}
          gameType={gameType}
        />
      ) : (
        <HeaderWithTimerMWeb
          matchItem={matchItem}
          onPressBack={onPressBack}
          onlyTimer={onlyTimer}
          onlyTitle={onlyTitle}
          onCalledDeadline={onCalledDeadline}
          teamName={teamName}
          gameType={gameType}
          isCreateTeam={isCreateTeam}
        />
      )}
    </React.Fragment>
  );
};
export default React.memo(HeaderWithTimer);
